import { SearchForTextResult } from "@aws-sdk/client-location";

export interface NormalizedLocation {
  label?: string;
  value?: string;
  place: {
    countryIsoCode3: string | null;
    houseNumber: string | null;
    postalCode: string | null;
    street: string | null;
    municipality: string | null;
    district: string | null;
    subRegion: string | null;
    subRegionName: string | null;
    label: string | null;
    region: string | null;
    regionName: string | null;
    unit: string | null;
    languageCode: string;
    matchLevelCode: string | null;
    latitude: number | null;
    longitude: number | null;
  };
}

export const normalizer = (
  locations: SearchForTextResult[],
  allowedTypes: string[] = []
): NormalizedLocation[] => {
  if (allowedTypes.length > 0) {
    locations = locations.filter(
      (l) =>
        l?.Place?.Categories?.[0] &&
        allowedTypes.includes(l?.Place?.Categories?.[0])
    );
  }
  return (
    locations?.map((l) => {
      return {
        label: l?.Place?.Label,
        value: l.PlaceId,
        place: {
          countryIsoCode3: l?.Place?.Country || null,
          houseNumber: l?.Place?.AddressNumber || null,
          postalCode: l?.Place?.PostalCode || null,
          street: l?.Place?.Street || null,
          municipality: l?.Place?.Municipality || null,
          district: l?.Place?.Neighborhood || null,
          subRegion: l?.Place?.SubRegion || null,
          subRegionName: l?.Place?.SubRegion || null,
          label: l?.Place?.Label || null,
          region: l?.Place?.Region || null,
          regionName: l?.Place?.Region || null,
          unit: l?.Place?.UnitNumber || null,
          languageCode: "IT",
          matchLevelCode: l?.Place?.Categories?.[0] || null,
          latitude: l?.Place?.Geometry?.Point?.[1] || null,
          longitude: l?.Place?.Geometry?.Point?.[0] || null,
        },
      };
    }) || []
  );
};
